<template>
    <div class="text-xs text-bzMenuText font-bold">
        <slot />
    </div>
</template>